import * as React from 'react'

function SvgTrashCan(props, svgRef) {
  return (
    <svg viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        d="M1.313 19.031A1.969 1.969 0 003.28 21h11.813a1.969 1.969 0 001.969-1.969V5.25H1.313v13.781zm11.156-10.5a.656.656 0 111.312 0v9.188a.656.656 0 11-1.312 0V8.53zm-3.938 0a.656.656 0 111.313 0v9.188a.656.656 0 01-1.313 0V8.53zm-3.937 0a.656.656 0 111.312 0v9.188a.656.656 0 01-1.312 0V8.53zm13.125-7.218h-4.922L12.41.546A.984.984 0 0011.53 0H6.84a.973.973 0 00-.877.546l-.386.767H.656A.656.656 0 000 1.969V3.28a.656.656 0 00.656.657H17.72a.656.656 0 00.656-.657V1.97a.656.656 0 00-.656-.656z"
        fill="#CF0000"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgTrashCan)
export default ForwardRef
